import { Injectable } from '@angular/core';
//import { User } from '../../pages/users/user.model';
import { User } from '../../pages/users/users.model';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor() { }

  public static checkPermissions(moduleId: number): boolean {
    let permission = false;
    
    Object.keys(this.getUser().rolePermissions).forEach(key => {
        if (AuthService.getUser().rolePermissions[key].module_id === moduleId) {
              permission = true;
        }
      });

      return permission;
    }

    public static getUser(): User {
      return JSON.parse(sessionStorage.getItem('user'));
    }

    public static isAdmin(): boolean {
      return parseInt(sessionStorage.getItem('roleId')) === 1;
    }

    public static isSuperAdmin(): boolean {
      return parseInt(sessionStorage.getItem('roleId')) === 0;
    } 

    public static loggedOut() {
      //console.log('Loggedout');
      sessionStorage.removeItem('isLoggedIn');
      sessionStorage.removeItem('user');
      //sessionStorage.removeItem('chats');
      //sessionStorage.removeItem('themeSettings');
      //sessionStorage.removeItem('lastLogin');
  }
}
